import { FormikErrors } from 'formik';
import { Provider } from '~/Models/DTO/Provider.model';

export const settingsDetailVerification = (data: Provider) => {
  const errors = {} as FormikErrors<Provider>;

  if (!data.name) {
    errors.name = 'missing';
  }

  return errors;
};
